
const To404NotFound = () => {
  return (
    <div className='w-full min-h-screen bg-white flex flex-col items-center justify-center space-y-4'>
        <span className='text-8xl font-semibold text-brand-500'>404</span>
        <span className="text-3xl">Xin lỗi, không tìm thấy trang</span>
    </div>
  )
}

export default To404NotFound